import { EntityInputFormInfo } from "@/common/ts/entity";
import { DamageDetectionDto } from "@/core/api/generated/v1";

export interface DamageDetectionFormPermissions {
  canEdit: boolean;
  canEditVehicle: boolean;
  canEditContract: boolean;
  canSplitItem: boolean;
  canMergeItems: boolean;
  canEditItem: boolean;
  canDeleteItem: boolean;
}

export class DamageDetectionHelper {
  public static getEntityFormPermissions(params: {
    formInfo: EntityInputFormInfo;
    entity: Nil<DamageDetectionDto>;
  }): DamageDetectionFormPermissions {
    return {
      canEdit: true, // params.formInfo.isCreate,
      canEditVehicle: params.formInfo.isCreate,
      canEditContract: false,
      canSplitItem: params.formInfo.isUpdate,
      canMergeItems: params.formInfo.isUpdate,
      canEditItem: true,
      canDeleteItem: true,
    };
  }
}
